import { gatewayAmazonConnect } from "../../../../gateways/gatewayAmazonConnect";

export const fetchPortingRecord = async (companyId: string | number) => {
  try {
    const { data } = await gatewayAmazonConnect.get(`/porting/${companyId}`);
    return data.data;
  } catch (error: any) {
    if (error.response?.status === 404) return null;
    console.error("Error fetching porting record:", error);
    throw new Error("Error fetching porting record");
  }
};
